import React from 'react';

import IBCard from '@totem/components/ui_components/antDesignOverrides/IBCard';
import ContentLayout from '@totem/components/ui_components/page/ContentLayout';
import MyWorkContainer from '@totem/components/users/myWork/MyWorkContainer';
import MyWorkLayout, {
  MyWorkExtra,
} from '@totem/components/users/myWork/MyWorkLayout';

const MyWorkPage = () => (
  <ContentLayout>
    <MyWorkContainer>
      <IBCard isCovered title="My Work" extra={<MyWorkExtra />}>
        <MyWorkLayout />
      </IBCard>
    </MyWorkContainer>
  </ContentLayout>
);

export default MyWorkPage;
